import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { emailLoginAction, forgotPasswordAction } from '../../redux/actions/authAction';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import successToast from '../../components/toast/successToast';
import errorToast from '../../components/toast/errorToast';
import logo from '../../assets/images/acumenVelocityLogo.svg';
import { Image, Spinner } from 'react-bootstrap'
/** Login using Email */
const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const initialValues = {
        email: '',
    }

    const onSuccess = (data) => {
        setLoading(false);
        navigate('/email-request-sent', { state: { message: 'Your request has been successfully verified. An email has been sent to the address associated with your account. Please check your inbox, as well as your spam or junk folder, for this email. If you do not receive it shortly, you are welcome to request another password reset.' } });
    }

    const onError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    }

    const validationSchema = Yup.object().shape({
        email: Yup.string()
            .required("Required").email("Invaild Email")
    });

    const onSubmit = (values) => {
        const dispatchingValues = {
            email: values.email
        }
        dispatch(forgotPasswordAction(dispatchingValues, onSuccess, onError))
        setLoading(true)
    }


    return (
        <div className='d-flex flex-column align-items-center justify-content-center w-100' style={{ height: '100vh', backgroundColor: '#e9eef7' }}>
            <div className='d-flex gap-2 justify-content-start align-items-center cursor_pointer w-100' style={{ height: '4rem' }} onClick={() => navigate('/')}>
                <Image alt='logo' src={logo} height={40} className='mx-1' />
                <p className='name fs_16 fw_700'>Acumen Translation Hub</p>
            </div>
            <div className="container d-flex justify-content-center align-items-center flex-grow-1 text-start" style={{ maxWidth: '30rem', width: '100%' }}>
                <div className="border bg-white p-4" style={{ width: '100%', borderRadius: '8px' }}>
                    <h5 className="card-title mb-4 text-nowrap">Forgot Password</h5>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        <Form>
                            <div className="mb-3">
                                <label htmlFor="email" className='py-1'>Email : </label>
                                <Field name={"email"}>
                                    {({ field, meta }) => (
                                        <div className="position-relative">
                                            <input
                                                {...field}
                                                placeholder="Enter your email"
                                                id={"email"}
                                                className="input-field"
                                                type={"email"}
                                                style={{ width: '90%' }}
                                            />
                                            <ErrorMessage name="email" component="div" className="text-danger" />
                                        </div>
                                    )}
                                </Field>
                            </div>
                            {loading && <div className="d-flex align-items-center text-center"><Spinner size='sm' className='text-primary' /> <span className='ms-2'>Sending Mail...</span></div>}
                            <div className='d-flex justify-content-between mt-4'>
                                <button type="" className="btn btn-primary" onClick={() => navigate('/')}>Back To Login</button>
                                <button type="submit" className="btn btn-primary" disabled={loading} >Send Link</button>
                            </div>
                        </Form>
                    </Formik>
                </div>
            </div>
        </div>

    );
};

export default ForgotPassword;
